import type {
  AssessableTasksResource,
  StudentTaskWithAssessmentsResource,
} from "api/generated";
import { portfolioShallowStudentFromDto } from "./portfolioShallowStudent.mapper";
import type {
  AssessableTask,
  AssessableTaskAssessment,
  StudentTaskAssessment,
} from "portfolio/types";
import type { StudentTaskWithAssessmentsResourceAssessment } from "api/generated/schemas/studentTaskWithAssessmentsResourceAssessment";

const assessmentFromDto = (
  dto: StudentTaskWithAssessmentsResourceAssessment,
): AssessableTaskAssessment => ({
  id: dto.id,
  value: dto.value,
  explanation: dto.explanation,
  allowRetry: dto.allow_retry as boolean | null,
});

export const studentTaskAssessmentFromDto = (
  dto: StudentTaskWithAssessmentsResource,
): StudentTaskAssessment => ({
  assignmentId: dto.assignment_id,
  activityId: (dto.activity_id as number) ?? null,
  activityTitle: dto.activity_title,
  student: portfolioShallowStudentFromDto(dto.student),
  status: dto.status,
  gradeValue: dto.grade_value ?? null,
  taskId: (dto.task_id as number) ?? null,
  completedAt: dto.completed_at ? new Date(dto.completed_at) : null,
  submittedAt: dto.submitted_at ? new Date(dto.submitted_at) : null,
  assessedAt: dto.assessed_at ? new Date(dto.assessed_at) : null,
  assessment: dto.assessment ? assessmentFromDto(dto.assessment) : null,
});

export const assessableTaskFromDto = (
  dto: AssessableTasksResource,
): AssessableTask => ({
  taskId: dto.task_id,
  title: dto.title,
  progress: dto.progress.map(studentTaskAssessmentFromDto),
});
